<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers /></el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">
								Add Existing Document for Revision
							</div>
				
							<div class="page_main">
								<div class="page-container">
									<el-form ref="formRef" :model="form" :rules="rules" label-position="top" class="doc-form">
				
										<!-- Document Number -->
										<el-form-item label="Document Number">
											<el-link type="primary" :underline="true">
												{{ form.ref2 }}
											</el-link>
										</el-form-item>
				
										<div class="btn_el">
											<div class="tips">
												Please update the document type, revision, and document name.
											</div>
										</div>
				
										<el-form-item label="Document Type">
											<el-input v-model="form.leixing_id2" disabled />
										</el-form-item>
				
										<el-form-item label="New Document Type" prop="leixing_id">
											<el-select
												v-model="form.leixing_id"
												placeholder="Please select a document type"
												class="full-width"
												clearable
											>
												<el-option
													v-for="value in resourcesLeixingList"
													:key="value.id"
													:label="value.title"
													:value="value.id"
												/>
											</el-select>
										</el-form-item>
				
										<br />
				
										<el-form-item label="Revision">
											<el-input v-model="form.vnumber2" disabled />
										</el-form-item>
				
										<el-form-item label="New Revision" prop="vnumber">
											<el-input
												v-model="form.vnumber"
												placeholder="Please enter the new revision"
											/>
										</el-form-item>
				
										<br />
				
										<el-form-item label="Document Name">
											<el-input v-model="form.vname2" disabled />
										</el-form-item>
				
										<el-form-item label="New Document Name" prop="vname">
											<el-input
												v-model="form.vname"
												placeholder="Please enter the document name"
											/>
										</el-form-item>
				
										<br />
				
										<div class="btn_el">
											<div class="tips">
												Please note that the approvals required for formal review depend on the document type, company, and department of each document.
											</div>
										</div>
				
										<!-- <el-form-item label="Company">
											<el-input v-model="form.company_id2" disabled />
										</el-form-item> -->
				
										<!-- <el-form-item label="New Company" prop="company_id">
											<div class="dept-row">
												<el-select
													v-model="form.company_id"
													placeholder="Please select a company"
													class="full-width"
													@change="getDepartment(form.company_id)"
												>
													<el-option
														v-for="value in companyList"
														:key="value.id"
														:label="value.company_name"
														:value="value.id"
													/>
												</el-select>
											</div>
										</el-form-item> -->
				
										<br />
				
										<el-form-item label="Department">
											<el-input v-model="form.departments_id2" disabled />
										</el-form-item>
				
										<el-form-item label="New Department" prop="departments_id">
											<div class="dept-row">
												<el-select
													v-model="form.departments_id"
													placeholder="Please select a department"
													class="full-width"
												>
													<el-option
														v-for="value in departmentsList"
														:key="value.id"
														:label="value.departments_name"
														:value="value.id"
													/>
												</el-select>
											</div>
										</el-form-item>
				
										<div class="divider" />
				
										<div class="btn_el">
											<div class="tips">
												Please update the reason for issuing the revised document and upload the new document file.
											</div>
										</div>
				
										<el-form-item label="Change Description">
											<el-input
												v-model="form.vdesc2"
												type="textarea"
												:rows="8"
												disabled
											/>
										</el-form-item>
				
										<el-form-item label="New Change Description" prop="vdesc">
											<el-input
												v-model="form.vdesc"
												type="textarea"
												:rows="8"
												placeholder="Please describe the changes made to this document."
											/>
										</el-form-item>
				
										<br />
				
										<el-form-item label="Document File">
											<div
												class="file-name"
												@click="viewFile(form.fileUrl2)"
											>
												{{ form.fileName2 }}
											</div>
										</el-form-item>
				
										<!-- Upload New Document -->
										<div class="upload-doc-wrapper">
											<div class="upload-title">
												New Document File
												<span class="upload-limit">
													(Maximum 10 MB)
												</span>
											</div>
				
											<div class="upload-box">
												<el-upload
													ref="uploadBox"
													class="doc-upload"
													action="/api/resourcesUploads"
													name="files"
													:headers="{ token: userToken }"
													:show-file-list="false"
													:before-upload="beforeAvatarUpload"
													:on-success="handleAvatarSuccess"
													:limit="1"
													:with-credentials="true"
												>
													<el-button size="medium" class="select-btn">
														Select File
													</el-button>
												</el-upload>
				
												<div
													class="file-name"
													:class="{ placeholder: !fileName }"
												>
													{{ fileName || "No file selected" }}
												</div>
											</div>
										</div>
				
									</el-form>
				
									<!-- Action Buttons -->
									<div class="btn_box">
										<van-button
											class="btn_el"
											type="default"
											round
											@click="handleCancel"
										>
											Cancel
										</van-button>
				
										<van-button
											class="btn_el"
											round
											color="linear-gradient(to right, #7BC1FF, #4886FF)"
											@click="handleSubmit"
										>
											Save
										</van-button>
									</div>
				
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { resourcesLeixingList } from '@/api/docManage/configureDocControl/index';
// import { companyList } from '@/api/system/company';
import { departmentsList } from '@/api/system/department';
import {
	resourcesVersionDetail,
	resourcesAdd
} from '@/api/docManage/changeRequest/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
export default {
	components: {
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			fileName: '',
			selectedFile: null,
			form: {
				leixing_id: '',
				ref: '',
				vnumber: '',
				vname: '',
				// company_id: '',
				departments_id: '',
				vdesc: '',
				leixing_id2: '',
				ref2: '',
				vnumber2: '',
				vname2: '',
				// company_id2: '',
				departments_id2: '',
				vdesc2: '',
				fileName2: '',
				fileUrl2: '',
				old_vid: null
			},
			rules: {
				leixing_id: [
					{ required: true, message: 'Please select', trigger: 'change' },
				],
				ref: [
					{ required: true, message: 'Please enter', trigger: 'blur' },
				],
				vnumber: [
					{ required: true, message: 'Please enter', trigger: 'blur' },
				],
				vname: [
					{ required: true, message: 'Please enter', trigger: 'blur' },
				],
				// company_id: [
				// 	{ required: true, message: 'Please select', trigger: 'change' },
				// ],
				departments_id: [
					{ required: true, message: 'Please select', trigger: 'change' },
				],
				vdesc: [
					{ required: true, message: 'Please enter', trigger: 'blur' },
				],
			},
			// companyList: [],
			departmentsList: [],
			resourcesLeixingList: [],
			userToken: localStorage.getItem('userToken'),
		};
	},
	created() {
		let that = this;
	},
	mounted() {
		let that = this;
		//请求文件类型
		resourcesLeixingList({ page: 1, page_size: 9999, keyword: '' }).then(res => {
			if(res.code == 200) {
				//请求公司列表
				// companyList({ page: 1, page_size: 9999, status: 1, company_name: '', company_userid: '', manage_userid: '' }).then(res2 => {
				// 	if(res2.code == 200) {
						that.resourcesLeixingList = res.data.data;
						// that.companyList = res2.data.data;
						//请求旧文件详情
						resourcesVersionDetail({ vid: that.$route.query.old_vid }).then(res3 => {
							if(res3.code == 200) {
								if(that.$route.query.type == 'edit') {
									//编辑
									that.form = {
										leixing_id: res3.data.leixing_id,
										ref: res3.data.ref,
										vnumber: res3.data.vnumber,
										vname: res3.data.vname,
										// company_id: res3.data.company_id,
										departments_id: '',
										vdesc: res3.data.vdesc,
										leixing_id2: res3.data.oldinfo.leixing_name,
										ref2: res3.data.oldinfo.ref,
										vnumber2: res3.data.oldinfo.vnumber,
										vname2: res3.data.oldinfo.vname,
										// company_id2: res3.data.oldinfo.company_name,
										departments_id2: res3.data.oldinfo.departments_name,
										vdesc2: res3.data.oldinfo.vdesc,
										fileName2: res3.data.oldinfo.image_info.name,
										fileUrl2: res3.data.oldinfo.image_info.url,
										old_vid: res3.data.oldinfo.vid
									};
									that.fileName = res3.data.image_info.name;
									that.selectedFile = res3.data.image_info.id;
									that.$nextTick(() => {
										that.getDepartment(res3.data.departments_id);
									})
								}else {
									//添加
									that.form.leixing_id2 = res3.data.leixing_name;
									that.form.ref2 = res3.data.ref;
									that.form.vnumber2 = res3.data.vnumber;
									that.form.vname2 = res3.data.vname;
									// that.form.company_id2 = res3.data.company_name;
									that.form.departments_id2 = res3.data.departments_name;
									that.form.vdesc2 = res3.data.vdesc;
									that.form.fileName2 = res3.data.image_info.name;
									that.form.fileUrl2 = res3.data.image_info.url;
									that.selectedFile = res3.data.image_info.id;
									that.$nextTick(() => {
										that.getDepartment();
									})
								}
							}
							that.isLoading = false;
						});
				// 	}
				// });
			}
		});
	},
	watch: {
		//
	},
	methods: {
		//请求部门列表
		getDepartment(val) {
			let that = this;
			that.form.departments_id = '';
			that.departmentsList = [];
			that.$toast.loading({ duration: 0, forbidClick: true });
			departmentsList({ page: 1, page_size: 9999, status: 1, departments_name: '', departments_userid: '' }).then(res2 => {
				that.$toast.clear();
				that.departmentsList = res2.data.data;
				if(val) {
					that.form.departments_id = Number(val);
				}
			});
		},
		handleAvatarSuccess(res, file) {
			let that = this;
			if (!file && !res) return;
			that.selectedFile = res.data.id;
			that.fileName = res.data.name;
			that.$toast.clear();
		},
		beforeAvatarUpload(file) {
			let that = this;
			const maxSize = 10 * 1024 * 1024; // 10MB
			const isLt100M = file.size <= maxSize;
			if(!isLt100M) {
				that.$message.error("Uploaded file size cannot exceed 10MB");
				return false;
			}
			that.$toast.loading({ duration: 0, forbidClick: true });
		},
		//提交
		handleSubmit() {
			let that = this;
			that.$refs.formRef.validate((valid) => {
				if(!valid) return;
				let query = {
					id: that.$route.query.oid,
					operation: 2,
					// company_id: that.form.company_id,
					departments_id: that.form.departments_id,
					leixing_id: that.form.leixing_id,
					ref: that.form.ref2,
					vname: that.form.vname,
					vdesc: that.form.vdesc,
					vnumber: that.form.vnumber,
					image_id: that.selectedFile,
					flow_type: 'resources_update'
				};
				if(that.$route.query.type == 'edit') {
					//编辑
					query.old_vid = that.form.old_vid;
					query.vid = that.$route.query.old_vid;
				}else {
					//添加
					query.old_vid = that.$route.query.old_vid;
					query.vid = '';
				}
				// console.log(query);
				that.$toast.loading({ duration: 0, forbidClick: true });
				resourcesAdd(query).then(res => {
					if(res.code == 200) {
						that.$toast.clear();
						that.$message.success('Operation successful');
						setTimeout(() => {
							that.$router.push({ path: '/task-list' });
						}, 800);
					}
				});
			});
		},
		handleCancel() {
			let that = this;
			that.$router.back();
		},
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
		//查看文件
		viewFile(value) {
			window.open(value);
		}
	},
};
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
	.btn_box{
		text-align: center;
		.btn_el{
			margin-left: 10px;
			padding: 12px 24px;
			.van-button__text{
				font-size: 16px;
			}
		}
	}
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}
::v-deep .btn span {
  text-decoration: underline;
}

.page-container {
  min-height: 100vh;
  padding: 12px 14px 30px;
  box-sizing: border-box;
}

.doc-form {
  width: 100%;
}

::v-deep .el-form-item {
  margin-bottom: 14px;
}

::v-deep .el-form-item__label {
  font-size: 14px;
  color: #333;
  line-height: 20px;
  padding-bottom: 6px;
  font-weight: 600;
}

::v-deep .el-input__inner {
  height: 42px;
  line-height: 42px;
  border-radius: 6px;
  /* background: #eef1f5; */
  border: 1px solid #cfcfcf;
  color: #333;
}

::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #e9edf2;
  color: #333;
}

::v-deep .el-select .el-input__inner {
  background: #fff;
}

.full-width {
  width: 100%;
}

.required-star {
  color: #f56c6c;
  margin-left: 2px;
}

.dept-row {
  display: flex;
  align-items: center;
}

.dept-input {
  flex: 1;
  margin-right: 0;
}

.dept-row .el-button {
  margin-left: -1px;
  height: 42px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 0 18px;
}

::v-deep .el-link {
  font-size: 16px;
  font-weight: 500;
}

::v-deep .el-link--inner {
  word-break: break-all;
}

.upload-doc-wrapper {
  width: 100%;
  margin-bottom: 40px;
  box-sizing: border-box;
}

.upload-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 14px;
  font-weight: 500;
}

.upload-limit {
  color: #666;
  font-weight: 400;
}

.upload-box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f7fa;
}

.doc-upload {
  flex-shrink: 0;
}

.select-btn {
  height: 44px;
  border: none;
  border-right: 1px solid #dcdfe6;
  border-radius: 0;
  background: #f5f7fa;
  color: #333;
  padding: 0 20px;
}

.select-btn:hover,
.select-btn:focus {
  background: #eef1f6;
  color: #333;
}

.file-name {
  flex: 1;
  height: 44px;
  line-height: 44px;
  padding: 0 16px;
  font-size: 15px;
  color: #333;
  background: #f5f7fa;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-name.placeholder {
  color: #999;
}

.divider {
  height: 1px;
  background: #d9d9d9;
  margin: 28px 0 20px;
}

.form-actions {
  display: flex;
  align-content: center;
  justify-content: center;
  gap: 12px;
}
</style>

